import React, { Component } from 'react';

import StandingsContainer from 'screens/standingsScreen/StandingsContainer';

import './screen.scss';

class Screens extends Component {
  render() {
    return (
      <div className="standings-app-container">
        <StandingsContainer { ...this.props } />
      </div>
    );
  }
}

export default Screens;


// WEBPACK FOOTER //
// ./src/screens/Screens.jsx